<template>
  <section :class="['dn-grid', 'dn-inline-ad', 'dn-grid-full', adGroupClass]">
    <template v-if="enabledAds && enabledAds.length > 0">
      <dn-ad
        v-for="childAd in enabledAds"
        :key="childAd.id"
        :ad="childAd"
        :class="childAd?.class"
        :is-ad-group-child="true"
      />
    </template>
  </section>
</template>
<script setup lang="ts">
const props = defineProps({
  childAds: {
    type: Array,
    required: true
  }
});
const enabledAds = computed(() => (props.childAds || []).filter((ad: any) => shouldShowAd(ad)));
const adGroupClass = computed(() => {
  switch (enabledAds.value.length) {
    case 2:
      return 'layout-bb';
    case 3:
      return 'layout-bbb';
    case 4:
      return 'layout-bbbb';
    default:
      return '';
  }
});
</script>
